import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ebd5680"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-box" }
const _hoisted_2 = { class: "btn-box" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("筛选")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = { class: "flex-box" }
const _hoisted_6 = { class: "operate-box" }

import { ref, Ref, reactive, nextTick, computed, watch } from 'vue'
import { cloneDeep, debounce } from 'lodash'
import { ArrowDown } from '@element-plus/icons'
import InputRange from './input-range.vue'
import { ISearchConfig } from '../../model'
import {
  ElButton,
  ElInput,
  ElSelect,
  ElOption,
  ElDatePicker,
  ElSwitch,
  ElIcon
} from 'element-plus'

/**
 * 使用说明
 * field: 字段名
 * type: select / input / daterange / datetimernage / inputrange / switch
 * defaultShow: 是否默认显示（在折叠状态下）
 * default: 默认值
 * multiple: 是否多选
 */


export default /*#__PURE__*/_defineComponent({
  props: {
  searchConfig: {
    type: Array as () => ISearchConfig[],
    default: () => []
  },
  labelStyle: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    type: Object as any,
    default: () => ({})
  }
},
  emits: ['search'],
  setup(__props, { emit: emits }) {

const props = __props





const reactiveData = reactive({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchForm: {} as any
})

const searchArea: Ref<HTMLElement | null> = ref(null)
const configList: Ref<ISearchConfig[]> = ref([])
const isCollapse = ref(true)
let cloneForm = {}

const isShowCollapse = computed(() => {
  if (isCollapse.value) {
    return props.searchConfig.length !== configList.value.length
  } else {
    return true
  }
})

const defaultList = computed(() => props.searchConfig.filter(item => item.defaultShow))

const shortcuts = [
  {
    text: '近七天',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      return [start, end]
    }
  },
  {
    text: '近一个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      return [start, end]
    }
  },
  {
    text: '近三个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      return [start, end]
    }
  }
]

window.onresize = debounce(() => {
  setSearchNumber()
}, 20)

function handleCollapse () {
  isCollapse.value = !isCollapse.value
  setSearchNumber()
}

function setSearchNumber () {
  configList.value = []
  // 获取 searchArea 宽度
  if (isCollapse.value) {
    nextTick(() => {
      // 如果是折叠状态
      if (searchArea.value) {
        const width = searchArea.value.clientWidth - 250
        let sumWidth = 0
        defaultList.value.forEach(item => {
          if (item.width && (sumWidth + item.width < width)) {
            configList.value.push(item)
            sumWidth += item.width
          }
        })
      }
    })
  } else {
    // 如果是展开状态
    configList.value = props.searchConfig
  }
}

function handleSearch () {
  emits('search', reactiveData.searchForm)
}

function resetForm () {
  reactiveData.searchForm = cloneDeep(cloneForm)
  handleSearch()
}

function init () {
  reactiveData.searchForm = {}
  props.searchConfig.forEach(item => {
    if (item.default !== undefined) {
      reactiveData.searchForm[item.field] = item.default
    }
    item.width = ['daterange', 'datetimerange'].includes(item.type) ? 480 : 240
  })
  cloneForm = cloneDeep(reactiveData.searchForm)
  setSearchNumber()
}

init()

watch(() => props.searchConfig, () => {
  init()
})


return (_ctx: any,_cache: any) => {
  const _directive_ellipsis = _resolveDirective("ellipsis")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "search-area",
      ref: (_value, _refs) => {
        _refs['searchArea'] = _value
        searchArea.value = _value
      },
      style: _normalizeStyle({'flex-wrap': isCollapse.value ? 'nowrap' : 'wrap'})
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "search-item",
          key: index
        }, [
          _withDirectives(_createElementVNode("span", {
            style: _normalizeStyle(__props.labelStyle)
          }, [
            _createTextVNode(_toDisplayString(item.label), 1)
          ], 4), [
            [_directive_ellipsis]
          ]),
          (item.type === 'select')
            ? (_openBlock(), _createBlock(_unref(ElSelect), {
                key: 0,
                modelValue: _unref(reactiveData).searchForm[item.field],
                "onUpdate:modelValue": ($event: any) => ((_unref(reactiveData).searchForm[item.field]) = $event),
                clearable: "",
                placeholder: item.placeholder,
                multiple: item.multiple === undefined ? true : item.multiple,
                "collapse-tags": ""
              }, {
                default: _withCtx(() => [
                  (item.options && Array.isArray(item.options))
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.options, (itemOp) => {
                        return (_openBlock(), _createBlock(_unref(ElOption), {
                          key: itemOp.value,
                          value: itemOp.value,
                          label: itemOp.label
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "multiple"]))
            : (item.type === 'input')
              ? (_openBlock(), _createBlock(_unref(ElInput), {
                  key: 1,
                  modelValue: _unref(reactiveData).searchForm[item.field],
                  "onUpdate:modelValue": ($event: any) => ((_unref(reactiveData).searchForm[item.field]) = $event),
                  clearable: "",
                  placeholder: item.placeholder
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
              : (['daterange', 'datetimerange'].includes(item.type))
                ? (_openBlock(), _createBlock(_unref(ElDatePicker), {
                    key: 2,
                    modelValue: _unref(reactiveData).searchForm[item.field],
                    "onUpdate:modelValue": ($event: any) => ((_unref(reactiveData).searchForm[item.field]) = $event),
                    type: item.type,
                    "unlink-panels": "",
                    "range-separator": "-",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间",
                    shortcuts: shortcuts
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "type"]))
                : (item.type === 'inputrange')
                  ? (_openBlock(), _createBlock(InputRange, {
                      key: 3,
                      modelValue: _unref(reactiveData).searchForm[item.field],
                      "onUpdate:modelValue": ($event: any) => ((_unref(reactiveData).searchForm[item.field]) = $event),
                      clearable: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (item.type === 'switch')
                    ? (_openBlock(), _createBlock(_unref(ElSwitch), {
                        key: 4,
                        modelValue: _unref(reactiveData).searchForm[item.field],
                        "onUpdate:modelValue": ($event: any) => ((_unref(reactiveData).searchForm[item.field]) = $event),
                        "active-value": item.activeValue === undefined ? true : item.activeValue,
                        "inactive-value": item.inactiveValue === undefined ? false : item.inactiveValue,
                        "active-text": item.activeText,
                        "inactive-text": item.inactiveText
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "active-value", "inactive-value", "active-text", "inactive-text"]))
                    : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ElButton), {
          type: "primary",
          onClick: handleSearch
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          plain: "",
          onClick: resetForm
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        (_unref(isShowCollapse))
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              type: "text",
              onClick: handleCollapse
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _createTextVNode(_toDisplayString(isCollapse.value ? '展开' : '收起') + " ", 1),
                  _createVNode(_unref(ElIcon), {
                    class: "el-icon--right icon-arrow",
                    style: _normalizeStyle({transform: isCollapse.value ? 'rotate(0deg)' : 'rotate(180deg)'})
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowDown))
                    ]),
                    _: 1
                  }, 8, ["style"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})